import angular from 'angular';
import supportModule from '../../support.module';

class supportCaseService {
    constructor(
        $q,
        asuiTableTemplateResources,
        stringHelper,
        supportCaseApiService,
        supportConfigApiService
    ) {
        this.$q = $q;
        this.asuiTableTemplateResources = asuiTableTemplateResources;
        this.stringHelper = stringHelper;
        this.supportCaseApiService = supportCaseApiService;
        this.supportConfigApiService = supportConfigApiService;

        this.caseListConfig = {};
    }

    getCase(id) {
        return this.supportCaseApiService.getCase(id);
    }

    getCases(offset, limit, status, owner) {
        var criteria = {
            offset: offset,
            limit: limit,
            status: status,
            owner: owner
        };

        Object.keys(criteria).forEach(
            key => !criteria[key] && delete criteria[key]
        );

        return this.supportCaseApiService.getCases(criteria);
    }

    getCaseListConfig() {
        if (Object.keys(this.caseListConfig).length > 0) {
            return this.$q.resolve(this.caseListConfig);
        }

        var deferred = this.$q.defer();

        this.supportConfigApiService.getCaseListConfig().then(data => {
            if (data && data.fields) {
                var columns = [];
                var empty = {
                    name: 'emptyColumn',
                    label: '',
                    sortable: false
                };
                columns.push(angular.copy(empty));
                columns.push(
                    angular.extend(
                        {
                            template: this.asuiTableTemplateResources
                                .supportCaseHistoryIcon
                        },
                        empty
                    )
                );
                data.fields.forEach(item => {
                    if (item.name === 'status') {
                        item.template = this.stringHelper.format(
                            this.asuiTableTemplateResources
                                .supportCaseHistoryDefault,
                            [
                                `{{options.statusValues[item.${
                                    item.name
                                }].label}}`
                            ]
                        );
                    } else {
                        item.template = this.stringHelper.format(
                            this.asuiTableTemplateResources
                                .supportCaseHistoryDefault,
                            [
                                `{{item.${item.name}${
                                    item.type === 'datetime'
                                        ? ' | datetime: "d"'
                                        : ''
                                }}}`
                            ]
                        );
                    }

                    if (item.link === true) {
                        item.template = this.stringHelper.format(
                            this.asuiTableTemplateResources
                                .supportCaseHistoryLink,
                            [item.template]
                        );
                    }
                    columns.push(item);
                });
                columns.push(angular.copy(empty));
                this.caseListConfig.columns = columns;
            }

            if (data && data.filters) {
                var filters = data.filters.reduce((obj, item) => {
                    obj[item.name] = item;
                    return obj;
                }, {});
                this.caseListConfig.filters = filters;
            }
            deferred.resolve(this.caseListConfig);
        }, deferred.reject);

        return deferred.promise;
    }
}

export default supportModule.service('supportCaseService', supportCaseService);



// WEBPACK FOOTER //
// ./modules/support/services/supportCase/supportCase.service.js